var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: "phone-number phone-number-align-" + _vm.localAlign },
    [
      !_vm.editingFieldLabel
        ? _c(
            "label",
            {
              staticClass: "field-label",
              attrs: { for: "phone-number" },
              on: { click: _vm.focusFieldLabel },
            },
            [
              _vm._v(
                "\n        " + _vm._s(_vm.displayFieldPhone) + "\n        "
              ),
              _vm.isRequired
                ? _c("span", { staticClass: "required-indicator" }, [
                    _vm._v("*"),
                  ])
                : _vm._e(),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.editingFieldLabel
        ? _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.localFieldPhone,
                expression: "localFieldPhone",
              },
            ],
            ref: "fieldLabelInput",
            staticClass: "field-label-input",
            attrs: { type: "text", placeholder: "Telefon" },
            domProps: { value: _vm.localFieldPhone },
            on: {
              blur: _vm.stopEditingFieldLabel,
              keydown: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.stopEditingFieldLabel.apply(null, arguments)
              },
              input: function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.localFieldPhone = $event.target.value
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { class: ["input-wrapper", { filled: _vm.phoneNumberValue }] },
        [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.phoneNumberValue,
                expression: "phoneNumberValue",
              },
            ],
            class: { "has-value": _vm.phoneNumberValue },
            attrs: { type: "tel", id: "phone-number", name: "phone-number" },
            domProps: { value: _vm.phoneNumberValue },
            on: {
              input: [
                function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.phoneNumberValue = $event.target.value
                },
                _vm.updateField,
              ],
              focus: _vm.onFocus,
              blur: _vm.onBlur,
            },
          }),
          _vm._v(" "),
          _c(
            "label",
            { staticClass: "floating-label", attrs: { for: "phone-number" } },
            [_vm._v(_vm._s(_vm.localMasked || "Telefon numaranızı giriniz"))]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "input-border" }),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }